import { useState, useEffect } from "react";
import "../styles/ScrollToTopButton.css";
import scrollIcon from "../assets/icons/scroll-up.svg";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Funkcja sprawdzająca pozycję scrolla
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  // Funkcja przewijająca stronę na górę
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // płynne przewijanie
    });
  };

  return (
    <button onClick={scrollToTop} className={`scroll-to-top-button ${isVisible ? "show" : ""}`}>
    <img src={scrollIcon} className="scroll-to-top-icon" alt="Scroll to top"/>
    </button>
  );
};

export default ScrollToTopButton;